import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

class EightMinutesAbs extends Component {
  state = {
    menuToggled: false,
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>Exercice de 8 Minutes pour abdos</title>

          <meta
            name="description"
            content="S'il s'agit d'un entraînement seul que nous ne mettons en place qu'à un moment donné
              pendant la journée ou s'il est ajouté à la fin d'un entraînement plus long, il est important de garder cette séance d'entraînement pour les abdominaux."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/8-minutes-abs" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="S'il s'agit d'un entraînement seul que nous ne mettons en place qu'à un moment donné
              pendant la journée ou s'il est ajouté à la fin d'un entraînement plus long, il est important de garder cette séance d'entraînement pour les abdominaux."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://cdn.fitzet.com/static%2Fbasiccrunch.jpg?alt=media"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          {/*this.state.menuToggled ? <MenuFunc off={this.setmenuoff} /> : null*/}
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div className="Screen">
          <div style={{ padding: "55px 20px 20px 20px" }}>
            <h2>8 Minutes Abs Workout</h2>
            <div style={{ display: "flex" }}>
              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fbasiccrunch.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="abs Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fcsitrotation.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="abs Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fcrossovercrunch.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="abs Exercises"
                />
              </div>
            </div>
            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              S'il s'agit d'un entraînement seul que nous ne mettons en place qu'à un moment donné
              pendant la journée ou s'il est ajouté à la fin d'un entraînement plus long, il est important de garder cette séance{" "}
              <strong>d'entraînement pour les abdominaux</strong>.
            </p>

            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Nous avons aussi des excercices pour le tron central mais pas pour la raison dont vous imaginez. Nous ne le faisons pas pour avoir des "plaquettes de chocolat" quand nous exerçons <strong>nos abdos</strong>, mais pour améliorer les muscles du tron central et les rendre plus forts et plus endurants.
            </p>

            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Chez <strong>BoxFit</strong>, nous avons choisi les meilleurs exercices d'abdos pour vous. Cliquez sur le bouton ci-dessous pour commencer votre sessions d'abdos. 
            </p>

            <p style={{ fontSize: "18px", marginTop: "20px" }}>
              <button
                style={{
                  fontSize: "18px",
                  background: "#69C9D0",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                }}
                onClick={() => {
                  this.props.history.push({
                    pathname: "/start-workout/abs",
                  });
                }}
              >
                Commencer l'entraînement{" "}
                <span role="img" aria-label="like">
                  🔥
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(EightMinutesAbs);
